import React from 'react';
import { Spinner } from 'react-bootstrap';

import Accordion from 'components/Accordion';
import usePopularComparisons from 'utils/hooks/meteorology/usePopularComparisons';
import PopularComparison from './PopularComparison';

import './index.scss';

export default function PopularComparisonsAccordion() {
  const { comparisons, isFetching } = usePopularComparisons();

  return (
    <Accordion.Item eventKey="0">
      <Accordion.Header>Comparações populares</Accordion.Header>
      <Accordion.Body className="text-center popular-comparisons-list">
        {isFetching && <Spinner />}
        {!isFetching && (
          comparisons.map((comparison) => (
            <PopularComparison
              key={comparison.id}
              comparison={comparison}
            />
          ))
        )}
      </Accordion.Body>
    </Accordion.Item>
  );
}
